export default "__VITE_ASSET__6f3e56b0__"